module.exports = __webpack_public_path__ + "static/media/solution1.e5e15440.jpg";